.s-product-card {
  &-entry {}

  &-image {
    &::before {
      font-family: "sallaicons";
      content: "\ec1f" !important;
    }
  }

  &-vertical {}

  &-horizontal {}

  &-fit-height {}

  &-special {}

  &-full-image {}

  &-minimal {}

  &-donation {}

  &-shadow {}

  &-out-of-stock {}

  &-wishlist-btn {}

  &-content {
    &-main {}

    &-sub {}

    &-footer {}

    &-title {}

    &-subtitle {}

    &-pie {
      &-svg {
        circle {
          transition: stroke-dashoffset 1s linear;
          -webkit-transition: stroke-dashoffset 1s linear;
          -moz-transition: stroke-dashoffset 1s linear;
          -ms-transition: stroke-dashoffset 1s linear;
          -o-transition: stroke-dashoffset 1s linear;
          stroke: #E8EDF2;
          stroke-width: 2px;
          stroke-linecap: round;
          fill: none
        }

        &-base {}

        &-bar {
          stroke: var(--color-primary) !important;
          stroke-dasharray: 100 100;
          stroke-dashoffset: 100
        }
      }
    }

    // for special card
    &-extra-padding {}
  }

  &-donation-input {}
}
